<template>
  <div>
    <Navbar/>
    <h4></h4>
<!-- Master -->
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idAsegurador" class="form-label">IdAsegurador</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idAsegurador" name="idAsegurador" v-model="datoAsegurador.idAsegurador" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="nombre" class="form-label">Nombre</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="nombre" name="nombre" v-model="datoAsegurador.nombre" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="tipo" class="form-label">Tipo</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="tipo" name="tipo" v-model="datoAsegurador.tipo" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
        <button type="submit" class="btn btn-light" @click.prevent="guardarAsegurador" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditAsegurador" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>

<!-- Details -->
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td class="centro">
              <button type="submit" class="btn btn-light" @click.prevent="getDataPagina(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td class="centro">
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">IdTarifario</th>
          <th scope="col">IdClasElem</th>
          <th scope="col">Descripcion</th>
          <th scope="col">FechaDesde</th>
          <th scope="col">FechaHasta</th>
          <th scope="col">Estado</th>
          <th scope="col">IdAsegurador</th>
          <th scope="col">ClasElemNombre</th>
          <th scope="col">AseguradorNombre</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="tarifario in datosPaginados" :key="tarifario.idTarifario">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(tarifario.idTarifario)" title="Editar">edit_square</i></td>
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirEditar(tarifario.idTarifario)" title="Editar">edit_square</i></td>
          <td>{{tarifario.idTarifario}}</td>
          <td>{{tarifario.idClasElem}}</td>
          <td>{{tarifario.descripcion}}</td>
          <td>{{getFormattedDate(tarifario.fechaDesde, 'DD/MM/YYYY')}}</td>
          <td>{{getFormattedDate(tarifario.fechaHasta, 'DD/MM/YYYY')}}</td>
          <td>{{tarifario.estado}}</td>
          <td>{{tarifario.idAsegurador}}</td>
          <td>{{tarifario.clasElemNombre}}</td>
          <td>{{tarifario.aseguradorNombre}}</td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deleteAsegurador(tarifario.idTarifario)" title="Borrar">delete</i></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPagina(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar_det">
              <div class="row">
                <div class="col-2">
                  <label for="idTarifario" class="form-label">IdTarifario</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idTarifario" name="idTarifario" v-model="datoTarifario.idTarifario" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <div class="row">
                  <div class="col-2">
                    <label for="idClasElem" class="form-label"> Clas Elem</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idClasElem" name="idClasElem" v-model="datoTarifario.idClasElem">
                      <option v-for="clasElem in clasElems" :value="clasElem.idClasElem" :key="clasElem.idClasElem">
                        {{ clasElem.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="descripcion" class="form-label">Descripcion</label>
                </div>
                <div class="col-10">
                <textarea class="form-control" id="descripcion" name="descripcion" v-model="datoTarifario.descripcion" style='text-transform:uppercase'></textarea>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaDesde" class="form-label">FechaDesde</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaDesde" name="fechaDesde" v-model="datoTarifario.fechaDesde" required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaHasta" class="form-label">FechaHasta</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaHasta" name="fechaHasta" v-model="datoTarifario.fechaHasta" required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idAsegurador" class="form-label">IdAsegurador</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idAsegurador" name="idAsegurador" v-model="datoTarifario.idAsegurador" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
        <button type="submit" class="btn btn-light" @click.prevent="guardarTarifario" v-if="btnCrear_det" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditTarifario" v-if="btnEditar_det" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Details -->

    <Footer/>
  </div>
</template>
<script>
import Navbar from '../../components/Navbar.vue'
import Footer from '../../components/Footer.vue'
import { validarForm } from '../../modules/validacionesForms.js';
import axios from 'axios'
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  components : {
    Navbar, Footer
  },
  data () {
    return {
// Variables master
      aseguradors : [],
      datoAsegurador : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      p_idAsegurador: '',
// Variables master
// Variables details
      tarifarios : [],
      datoTarifario : {},
      nombreBusqueda_det: '',
      titulo_det: '',
      btnCrear_det: false,
      btnEditar_det: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      clasElems : [],
      modalWindow: true
// Variables details
    }
  },
  mounted () {
    this.p_idAsegurador = this.$route.params.p_idasegurador
    this.abrirEditar(this.p_idAsegurador)
    this.getDataPagina(this.paginaActual)
  },
  methods : {
// Procedimientos master
    validarForm(){
      const requiredFields = [
        'nombre'
        ,'tipo'
      ];
      const requiredFieldsText = [
        'nombre'
        ,'tipo'
      ];
      return validarForm(this.datoAsegurador, requiredFields, requiredFieldsText);
    },
    async guardarAsegurador(){
      if(this.validarForm() === 1){
        try {
          await axios.post('http://localhost:8080/api/v1/aseguradors', this.datoAsegurador)
          swal("Correcto!", "Asegurador creada exitosamente!", "success");
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditAsegurador(){
      if(this.validarForm() === 1){
        try {
          await axios.post('http://localhost:8080/api/v1/aseguradors', this.datoAsegurador)
          swal("Correcto!", "Asegurador creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirCrear(){
      this.modalWindow = true
      this.datoAsegurador={}
      this.titulo   = 'Crear '
      this.btnCrear = true
      this.btnEditar= false
    },
    abrirEditar(idAsegurador){
      this.modalWindow = true
      if(idAsegurador != null){    
           axios.get('http://localhost:8080/api/v1/vwaseguradors/'+idAsegurador).then(resp=>{
          this.datoAsegurador = resp.data;
           });
      }
      this.titulo   = 'Editar '
      this.btnCrear = false
      this.btnEditar= true
    },
    cerrarAsegurador(){
      this.$router.push('/Asegurador')
    },
// Procedimientos master
// Procedimientos detalle
    totalPaginas(){
      return Math.ceil(this.tarifarios.length / this.elementosPorPagina)
    },
    getDataPagina(noPagina){
      if(this.nombreBusqueda != '') {
        axios.get('http://localhost:8080/api/v1/vwtarifarios/nombre/'+this.nombreBusqueda).then(response=>{ 
          this.tarifarios=response.data.reverse();  
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.tarifarios.slice(ini,fin);
        });
      }
    },
    getDataPaginaTodos(noPagina){
      axios.get('http://localhost:8080/api/v1/vwtarifarios').then(response=>{ 
      this.tarifarios=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.tarifarios.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarFormDet(){
      const requiredFields = [
        'nombre'
        ,'tipo'
      ];
      const requiredFieldsText = [
        'nombre'
        ,'tipo'
      ];
      return validarForm(this.datoAsegurador, requiredFields, requiredFieldsText);
    },
    async guardarTarifario(){
      if(this.validarForm() === 1){
        try {
          this.datoTarifario.idAsegurador = this.datoAsegurador.idAsegurador;
          await axios.post('http://localhost:8080/api/v1/tarifarios', this.datoTarifario)
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "Tarifario creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditTarifario(){
      if(this.validarForm() === 1){
        try {
          await axios.post('http://localhost:8080/api/v1/tarifarios', this.datoTarifario)
          $('#ventanaModal').modal('hide');
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "Tarifario creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoTarifario={}
      this.titulo   = 'Crear '
      this.btnCrear_det  = true
      this.btnEditar_det = false
    },
    abrirModalEditar(idTarifario){
      this.modalWindow = true
      if(idTarifario != null){    
           axios.get('http://localhost:8080/api/v1/vwtarifarios/'+idTarifario).then(resp=>{
          this.datoTarifario = resp.data;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar '
      this.btnCrear_det  = false
      this.btnEditar_det = true
    },
    abrirEditarDet(idTarifario){
      this.modalWindow = true
      if(idTarifario != null){
        this.$router.push('/tarifariomd/'+idTarifario)
      }
    },
    async deleteTarifario (idTarifario) {
      try{
        await axios.delete('http://localhost:8080/api/v1/tarifarios/'+idTarifario)
          this.getDataPagina(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
// Procedimientos detalle
    fetchClasElems() {
      fetch('http://localhost:8080/api/v1/claselems')
        .then(response => response.json())
        .then(data => {
          this.clasElems = data;
        })
        .catch(error => {
          console.error('Error fetching clasElems:', error);
        });
    },
    fetchAseguradors() {
      fetch('http://localhost:8080/api/v1/aseguradors')
        .then(response => response.json())
        .then(data => {
          this.aseguradors = data;
        })
        .catch(error => {
          console.error('Error fetching aseguradors:', error);
        });
    },
  },
}
</script>
